import { apiClient } from '../shared/services/api';

export interface Friend {
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  fullName: string;
  bio: string;
  avatarUrl: string | null;
  friendshipId: string;
  friendsSince: string;
}

export interface Friendship {
  id: string;
  requesterId: string;
  addresseeId: string;
  requesterName: string;
  requesterUsername: string;
  addresseeName: string;
  addresseeUsername: string;
  status: 'PENDING' | 'ACCEPTED' | 'REJECTED' | 'BLOCKED';
  createdAt: string;
  version: number;
}

export interface FriendshipLink {
  id: string;
  token: string;
  creatorId: string;
  expiresAt: string;
  maxUses: number | null;
  currentUses: number;
  isActive: boolean;
  createdAt: string;
  version: number;
}

export interface SendFriendRequestCommand {
  addresseeId: string;
}

export interface CreateFriendshipLinkCommand {
  expiresInHours?: number;
  maxUses?: number;
}

export const friendshipAPI = {
  // Friend requests
  sendFriendRequest: (command: SendFriendRequestCommand) =>
    apiClient.post<Friendship>('/friendships/send-request', command),
  
  acceptFriendRequest: (friendshipId: string) =>
    apiClient.post<Friendship>(`/friendships/${friendshipId}/accept`),
  
  rejectFriendRequest: (friendshipId: string) =>
    apiClient.post<Friendship>(`/friendships/${friendshipId}/reject`),
  
  blockUser: (friendshipId: string) =>
    apiClient.post<void>(`/friendships/${friendshipId}/block`),
  
  removeFriend: (friendshipId: string) =>
    apiClient.delete<void>(`/friendships/${friendshipId}`),
  
  // Friends
  getFriends: () =>
    apiClient.get<Friend[]>('/friendships/friends'),
  
  getFriendsPaginated: (page: number, size: number) =>
    apiClient.get<{
      content: Friend[];
      totalElements: number;
      totalPages: number;
      size: number;
      number: number;
    }>(`/friendships/friends/paginated?page=${page}&size=${size}`),
  
  getPendingRequests: () =>
    apiClient.get<Friendship[]>('/friendships/requests/pending'),
  
  getSentRequests: () =>
    apiClient.get<Friendship[]>('/friendships/requests/sent'),
  
  // Friendship links
  createFriendshipLink: (command: CreateFriendshipLinkCommand) =>
    apiClient.post<FriendshipLink>('/friendships/links', command),
  
  useFriendshipLink: (token: string) =>
    apiClient.post<Friendship>(`/friendships/links/${token}/use`),
  
  getUserLinks: () =>
    apiClient.get<FriendshipLink[]>('/friendships/links'),
  
  getUserActiveLinks: () =>
    apiClient.get<FriendshipLink[]>('/friendships/links/active'),
  
  deactivateLink: (linkId: string) =>
    apiClient.post<void>(`/friendships/links/${linkId}/deactivate`),
  
  deleteLink: (linkId: string) =>
    apiClient.delete<void>(`/friendships/links/${linkId}`),
};